const zhTW = {
	menu: {
		home: '首頁'
	},
	login: {
        LOGIN_LOGIN: '登 录',
        RESET:'重 置',
        LOGIN_FGT_PWD: '忘记密码?',
        LOGIN_REGISTER: '注 册',
        LOGIN_ACCOUNT: '请输入用户名',
        PASSWORD: '请输入密码',
        TITLE: '用户登录',
		"欢迎使用OMS":"欢迎使用OMS",
		"账号密码":"账号密码",
		"验证码":"验证码",
		"账号手机号码":"账号/手机号",
		"密码":"密码",
		"手机号码":"手机号码",
		"获取验证码":"获取验证码",
		"登录/注册":"登录/注册",
		"若手机号码尚未注册将为您自动注册账户":"若手机号码尚未注册，将为您自动注册账户",
		"请输入手机号码":"请输入手机号码",
		"登录失败":"登录失败",
		"登录成功":"登录成功",
		"请填写正确的手机号码":"请填写正确的手机号码",
		"秒":"秒",
		"重置密码": "重置密码",
		"欢迎登陆":"欢迎登陆",
		"跨境V5":"跨境V5",
		"云平台":"云平台",
		"邮件验证码":"邮件验证码",
		"账号":"账号",
		"新密码":"新密码",
		"再次输入新密码":"再次输入新密码",
		"确定":"确定",
		"返回登录":"返回登录",
    },
	button:{

	},
  hint: {
	switchLanguageSuccess: "選擇語言成功",
  },
	"page":{
		"SYS001":{

		},
	}
};
export default zhTW;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/zh-TW.js